import styled from 'styled-components'

import { GenericErrorPage } from 'components/Placeholders/GenericErrorPage/GenericErrorPage'

export const StyledGenericErrorPage = styled(GenericErrorPage)`
  justify-content: flex-start;
`
